import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgBareMetal = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-bare-metal';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M7.778 4.072a726 726 0 0 0-4.29 2.488l-.088.06.179.3.179.3-.369.02-.369.02-.01 4.945c-.008 3.926 0 4.953.04 4.985.027.023 1.913 1.116 4.19 2.43 2.277 1.313 4.196 2.422 4.264 2.463l.123.076.177-.319c.097-.175.185-.319.196-.319s.099.144.196.319l.177.319.123-.076c.068-.041 1.987-1.15 4.264-2.463a546 546 0 0 0 4.19-2.43c.04-.032.048-1.103.04-5.205l-.01-5.164-4.48-2.589A679 679 0 0 0 12 1.643c-.011 0-1.911 1.093-4.222 2.429m7.945 1.446 3.737 2.157v8.654l-3.34 1.928-3.34 1.928-.01-4.305-.01-4.306-3.737-2.157C6.968 8.231 5.295 7.252 5.305 7.242s1.516-.886 3.347-1.946 3.329-1.93 3.331-1.932 1.685.967 3.74 2.154M5.88 9.334l1.14.661.011 2.512.011 2.513 2.084 1.2c1.146.66 2.091 1.218 2.099 1.24s.011.645.006 1.383l-.011 1.342-3.34-1.928-3.34-1.928-.01-3.885-.01-3.886.11.058c.06.032.623.355 1.25.718m10 2.468c-1.133.657-2.064 1.217-2.07 1.246-.014.076.689 1.254.741 1.243.103-.022 4.169-2.394 4.166-2.431-.004-.068-.696-1.233-.738-1.243-.021-.004-.966.529-2.099 1.185m-5.965-.142 1.322.76.001 1.63c.001.897-.008 1.63-.02 1.63s-.624-.347-1.36-.77l-1.337-.77v-1.633c-.001-.969.014-1.628.036-1.62.02.007.631.355 1.358.773m5.958 3.486-2.107 1.219.367.637c.202.35.38.637.395.637.034.001 4.116-2.35 4.169-2.401.029-.029-.591-1.181-.692-1.284-.014-.014-.973.522-2.132 1.192"
    })
  }));
});
export default SvgBareMetal;